import { memo, useMemo } from "react";
import {
  UpdateProfileFormSection,
  NotificationSection,
  MyVideosSection,
  OrderHistorySection,
  TestimonialSection,
  RequestANurseSection,
  ConsultationsSection,
} from "@/design-system/Organisms/";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";

interface DashboardContentProps {
  activeTabId: string;
}

const DashboardContent = memo<DashboardContentProps>(({ activeTabId }) => {
  const contentComponents = useMemo(
    () => ({
      [DASHBOARD_TABS.NOTIFICATION]: <NotificationSection />,
      [DASHBOARD_TABS.ORDER]: <OrderHistorySection />,
      [DASHBOARD_TABS.MY_VIDEO]: <MyVideosSection />,
      [DASHBOARD_TABS.UPDATE]: <UpdateProfileFormSection />,
      [DASHBOARD_TABS.TESTIMONIAL]: <TestimonialSection />,
      [DASHBOARD_TABS.CONSULTATIONS]: <ConsultationsSection />,
      [DASHBOARD_TABS.REQUEST_A_NURSE]: <RequestANurseSection/>,
    }),
    []
  );

  return (
    <div className="w-full lg:w-8/12 relative">
      <div
        role="tabpanel"
        id={`${activeTabId}-panel`}
        aria-labelledby={activeTabId}
        className="w-full opacity-100 relative z-10 transition-opacity duration-200 ease-in-out"
      >
        {contentComponents[activeTabId as keyof typeof contentComponents]}
      </div>
    </div>
  );
});

DashboardContent.displayName = "DashboardContent";

export default DashboardContent;